import React, { useEffect, useState } from "react";
import { PaginationInitialData } from "../types/interface";

const limit = 20;
const maxLimit = 50;
const offset = 0;

const initialData: PaginationInitialData = {
  offset: offset,
  limit: limit,
  maxLimit: maxLimit,
  currentPage: 1,
  searchAfterId: [],
  queryString: `?limit=${limit}&offset=${offset}`,
  updateLimit: (limit: number) => { },
  updateCurrentPage: (currentPage: number) => { },
  setDefault: () => { },
  updateSearchAfterId: (id: number, date: string) => { },
};

export const PaginationContext = React.createContext(initialData);

const PaginationContextProvider = (props: any) => {
  useEffect(() => {
    let queryString = `?limit=${limit}&offset=${offset}`;
    setQueryString(queryString);
  }, []);

  const [offset, setOffset] = useState(initialData.offset);
  const [limit, setLimit] = useState(initialData.limit);
  const [currentPage, setCurrentPage] = useState(initialData.currentPage);
  const [queryString, setQueryString] = useState<string>(
    initialData.queryString
  );
  const [searchAfterId, setSearchAfterId] = useState([]);

  const updateLimitHandler = (limit: number = initialData.limit) => {
    setLimit(limit);
    updateOthers(limit, currentPage);
  };

  const updateCurrentPageHander = (
    currentPage: number = initialData.currentPage
  ) => {
    setCurrentPage(currentPage);
    updateOthers(limit, currentPage);
  };

  const updateOthers = (
    limit: number = initialData.limit,
    currentPage: number = initialData.currentPage
  ) => {
    let offset = limit * (currentPage - 1);
    setOffset(offset);

    let queryString = `?limit=${limit}&offset=${offset}`;
    if (currentPage > 500) {
      const afterId: any = searchAfterId.find(
        (item: any) => item.pageNumber === currentPage - 1
      );
      if (afterId) {
        queryString = `?limit=${limit}&offset=${offset}&search_after=${afterId.date},${afterId.id}`;
      }
    }
    setQueryString(queryString);
  };

  const updateSearchAfterId = (id: number, date: string) => {
    const newArray: any = [
      ...searchAfterId,
      { id: id, pageNumber: currentPage, date: date },
    ];
    if (newArray.length > 10) {
      newArray.splice(0, 1);
    }
    setSearchAfterId(newArray);
  };

  const setDefaultHandler = () => {
    updateLimitHandler();
    updateCurrentPageHander();
    updateOthers();
  };

  const contextValue = {
    offset: offset,
    limit: limit,
    maxLimit: initialData.maxLimit,
    currentPage: currentPage,
    queryString: queryString,
    searchAfterId: searchAfterId,
    updateLimit: updateLimitHandler,
    updateCurrentPage: updateCurrentPageHander,
    setDefault: setDefaultHandler,
    updateSearchAfterId: updateSearchAfterId,
  };

  return (
    <PaginationContext.Provider value={contextValue}>
      {props.children}
    </PaginationContext.Provider>
  );
};

export default PaginationContextProvider;
